import { Popover, FloatButton } from "antd";
import React from "react";
import * as d3 from "d3";
import { Row, Col } from "antd";
import { BgColorsOutlined } from "@ant-design/icons";

const colors = [
  { back: "dodgerblue", font: "white"},
  { back: "white", font: "#E91E63"},
  { back: "#3c4298", font: "#f2bab4"},
  { back: "#fef6e9", font: "#526d4e"},
  { back: "#F98866", font: "#FFF2D7"},
  { back: "#FBEAEB", font: "#2F3C7E"},
  { back: "#FEE715", font: "#101820"},
  { back: "#0688c6", font: "#f2b922"},
  { back: "#CADCFC", font: "#00246B"},
  { back: "#e64528", font: "#ece3d2"},
  { back: "#9851f2", font: "#000000"},
  { back: "#0532af", font: "#e74729"},
].map((d,i) => ({...d, id: i+1}))

const ColorButton = ({color, setColor}) => {
  return (
    <>
      <Popover
        placement="left"
        content={
          <Row type="flex" style={{margin: 8, width: (35*4) + (8 * 4), height: (35*4)}}>
            {
              colors.map(c => {
                const pie = d3.pie()([1, 1]);
                const arc = d3.arc()
                  .outerRadius(15);
                return <Col key={c.id} span={6}>
                  <svg 
                    width={30} 
                    height={30} 
                    style={{ overflow: "visible", width: 30, cursor: "pointer"}} 
                    onClick={() => setColor(c)}>
                      {pie.map((d, i) => <path key={i} transform={`translate(15,15) rotate(25)`} d={arc(d)} fill={ i!== 0 ? c.back : c.font} />)}
                      <circle fill='none' stroke="grey" strokeWidth={2} cx={15} cy={15} r={15}/>
                      {color && color.id ===c.id && <circle fill='none' stroke="grey" strokeWidth={2} cx={15} cy={15} r={19}/>}
                  </svg>
                </Col>})
              }
          </Row>
        }
      >
        <FloatButton icon={<BgColorsOutlined />} />
      </Popover>
    </>
  );
};

export default ColorButton;
